/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IBenefitsDataResult } from "Interfaces/Benefits/IBenefitsDataResult";
import { IBenefitsRequest } from "Interfaces/Benefits/IBenefitsRequest";

import { BENEFIT_BASE_URL } from "../Constants/SagaConstants";
import { IApiResult2 } from "../Interfaces/IApiResult";
import { post, IHttpResponse } from "./ApiUtils";

/**
 * Search all events for the given text.
 */
export async function searchBenefits(
  searchRequest: IBenefitsRequest,
  tenant: string
): Promise<IHttpResponse<IApiResult2<IBenefitsDataResult>>> {
  const url = BENEFIT_BASE_URL.replace("{tenant}", tenant) + "search";
  return await post<IApiResult2<IBenefitsDataResult>>(url, searchRequest, true);
}
